import React, { useEffect, useState, useRef, useContext } from 'react';
import { useForm, Controller, SubmitHandler } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import $ from 'jquery';
import * as Yup from 'yup';
/*import { yupResolver } from '@hookform/resolvers/yup';*/
import { CheckSession, FormatCurrency, GetCoockie, shopping_cart_session_id, DefaultImage, GetShoppingCart, UpdateShoppingCart, KImageURL, ValidateQty } from "../../GlobalScript";
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import CloseButton from 'react-bootstrap/CloseButton';
import PulseLoader from "react-spinners/PulseLoader";
//import Cookies from 'js-cookie';
import ReviewOrder from './ReviewOrder.js';
import ItemInquiry from '../ItemInquiry.js';
import FooterDealer from '../../FooterDealer.js';
import FileUpload from '../FileUpload.js';
import useLocalStorage from "use-local-storage";
import { ShoppingCartContext } from '../ShoppingCartContext';
export default function NewOrder() {
    const navigate = useNavigate();
    const [OrderTypes, setOrderTypes] = useState(null);
    const [DefaultShipTo, setDefaultShipTo] = useState(null);
    const [OrderName, setOrderName] = useState('');
    const [ShipTo, setShipTo] = useState(null);
    const [Sku, setSku] = useState('');
    const [Qty, setQty] = useState(1);
    const [SelectedOrderType, setSelectedOrderType] = useState(null);

    const [AccSubtotal, setAccSubtotal] = useState(0);
    const [ParSubtotal, setParSubtotal] = useState(0);
    const [OtherSubtotal, setOtherSubtotal] = useState(0);
    const [EstFreight, setEstFreight] = useState(0);
    const [EstHandling, setEstHandling] = useState(0);
    const [EstSpecialFee, setEstSpecialFee] = useState(0);
    const [Total, setTotal] = useState(0);
    const [PromoCode, setPromoCode] = useState('');
    const [ShipMethod, setShipMethod] = useState('');
    const [submit, setSubmit] = useState(false);
    const [OrderID, setOrderID] = useState(false);
    const [DealerIdInput, setDealerIdInput] = useState('');
    const [ShipToDealerID, setShipToDealerID] = useState('');
    const [showDealerModal, setShowDealerModal] = useState(false);
    const [importDealerModal, setImportDealerModal] = useState(false);

    const [fromImport, setFromImport] = useState(false);

    const [importInstructions, setImportInstructions] = useState(false);
    const handleShowImportInstructions = () => {
        setImportInstructions(true);
    }
    const handleCloseImportInstructions = () => {
        setImportInstructions(false);
    }

    const [selectedItems, setSelectedItems] = useState(new Map());
    const [showItemModal, setShowItemModal] = useState(false);
    //const [ValuesForItemInquiry, setValuesForItemInquiry] = useState(null);
    const [showPromo, setShowPromo] = useState(false);
    const [kCode, setKCode] = useState('');

    const [localQty, setLocalQty] = useState({});

    const [alerts, setAlerts] = useState([]);
    const hasAlert = (type) => alerts.some(alert => alert.type === type);

    const [ShipCodes, setShipCodes] = useState(null);
    const [ForwarderAddresses, setForwarderAddresses] = useState(new Map());
    const [SelectedForwarderAddress, setSelectedForwarderAddress] = useState(null);
    const [SelectedDropshipAddress, setSelectedDropshipAddress] = useState(null);
    const [ForwarderAdd, setForwarderAdd] = useState(null);
    const [DropShipAdd, setDropShipAdd] = useState(null);
    const [AllForwarderAddMap, setAllForwarderAddMap] = useState(null);
    const { shoppingCart, setShoppingCart } = useContext(ShoppingCartContext);
    /* const [ItemForShoppingCart, setItemForShoppingCart] = useState(null);*/
    /*    const { ShoppingCartItems, setShoppingCartItems } = useContext(ShoppingCartContext);*/
    const [BulkLoad, setBulkLoad] = useState(null);
    const [DealerIDChangeMsg, setDealerIDChangeMsg] = useState(null);
    //const [ShoppingCartSession, setShoppingCartSession] = useLocalStorage(shopping_cart_session_id, "");

    const [SelectedItemForModels, setSelectedItemForModels] = useState(null);
    const [Models, setModels] = useState(null);
    const [showModelModal, setShowModelModal] = useState(false);
    const [DealerChanged, setDealerChanged] = useState(false);
    const [ItemsNumberQtyArr, setItemsNumberQtyArr] = useState(null);
    const [UpdateMode, setUpdateMode] = useState(false);
    const handleModelModalShow = (itemNum) => {
        GetModels(itemNum);
        setShowModelModal(true);
    }

    const GetModels = async (itemnum) => {
        CheckSession();
        const response = await fetch("kdealer/GetModels/" + itemnum);
        if (response.status !== 200) {
            return;
        }
        const js = await response.json();
        const grouped = Object.groupBy(js.models, ({ year }) => year);
        const sortedGroups = Object.entries(grouped)
            .sort(([groupA], [groupB]) => groupB.localeCompare(groupA))
            .map(([group, models]) => {
                models.sort((a, b) => a.label - b.label);
                return { group, models };
            });
        setSelectedItemForModels({ itemNum: js.itemNum, itemName: js.itemName })
        console.log(sortedGroups);
        setModels(sortedGroups);
    }

    const handleModelModalClose = () => setShowModelModal(false);

    const [dropdownStates, setDropdownStates] = useState({});

    const [showMemo, setShowMemo] = useState({});

    const toggleMemo = (id) => {
        setShowMemo(prev => ({
            ...prev,
            [id]: !prev[id]
        }));
    }

    const toggleDropdown = (itemId, isOpen) => {
        setDropdownStates((prev) => ({
            ...prev,
            [itemId]: isOpen,
        }));
    };

    const [pop, setPop] = useState(false);

    const handlePop = () => setPop(true);
    const handleClosePop = () => setPop(false);

    const [SKUMemo, setSKUMemo] = useState(new Map());
    const [orderQty, setOrderQty] = useState(new Map());

    const handleDealerModalClose = () => {
        setShowDealerModal(false);
    }
    const handleDealerModalShow = () => {
        setShowDealerModal(true);
    };
    const ChangeDealer = async () => {
        handleDealerModalClose();
        if (DealerChanged) {
            setShipTo(DealerChanged);
            setShipToDealerID(DealerIdInput);
        }
    }

    const [showQtyModal, setShowQtyModal] = useState(false);
    const handleQtyModalShow = () => {
        setShowQtyModal(true);
    }

    const handleQtyModalClose = () => {
        setShowQtyModal(false);
    }

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const handleDeleteModalOpen = () => {
        setShowDeleteModal(true);
    }
    const handleDeleteModalClose = () => {
        setShowDeleteModal(false);
    }

    const handleImportModalClose = () => {
        setImportDealerModal(false);
    }
    const handleImportModalShow = () => {
        setImportDealerModal(true);
    }

    const importOrder = () => {
        handleImportModalClose();
    }

    const ChangeShipMethod = async (value) => {
        if (value === "") {
            setShipMethod(null);
            return;
        }
        ShipCodes.forEach(element => {
            if (element.key === value || element.shipCode === value) {
                setEstFreight(element.estFreightCost);
                setEstHandling(element.estHandlingCharge);
                setEstSpecialFee(element.estSpecialFee);
                setShipMethod(value);
            }
        });
    }
    const ChangeForwarderAddress = async (value) => {
        setForwarderAdd(value);
    }
    const ChangeDropShipAddress = async (value) => {
        setDropShipAdd(value);
    }

    useEffect(() => {
        if (ShipMethod && ForwarderAddresses && ShipMethod.substring(0, 1) === "I") {
            GetForwarderDropshipAddress(ShipMethod);
        }
    }, [ShipMethod, ForwarderAddresses])

    const ChangeOrderType = async (e) => {
        //handlePop();
        setSelectedOrderType(e.target.value);
        setUpdateMode(true);
        //handleClosePop();
    }

    const handleItemModalShow = () => {
        //let arr = [];
        //Array.from(selectedItems.values()).forEach(element => {
        //    arr.push({ sku: element.item.distitemNbr, qty: element.item.qty });
        //});
        //setValuesForItemInquiry(arr);
        setShowItemModal(true);
    }
    const handleItemModalClose = () => setShowItemModal(false);

    const handleSelectedItems = ({ items, alerts }, updateQty) => {
        //handlePop();
        const crrMap = new Map();
        const arr = [];
        const cart = GetShoppingCart();
        let acctotal = 0;
        let parttotal = 0;
        let othertotal = 0;
        const skuqty = [];
        const quantities = {};
        items.forEach(element => {
            crrMap.set(element.item.distitemNbr, element);
            const qty = element.item.qty + element.item.boCnt;
            if (element.item.inventoryType === "A") {
                parttotal += qty * element.item.dealerPrice;
            }
            else if (element.item.inventoryType === "B") {
                acctotal += qty * element.item.dealerPrice;
            }
            else {
                othertotal += qty * element.item.dealerPrice;
            }
            skuqty.push({
                sku: element.item.distitemNbr,
                qty: element.item.qtyOrdered
            });

            quantities[element.item.distitemNbr] = element.item.qtyOrdered;
        });

        setLocalQty(quantities);

        if (updateQty === false && cart && cart.items) {
            cart.items.forEach(element => {
                if (!crrMap.has(element.item.distitemNbr)) {
                    crrMap.set(element.item.distitemNbr, element);
                    const qty = element.item.qty + element.item.boCnt;
                    if (element.item.inventoryType === "A") {
                        parttotal += qty * element.item.dealerPrice;
                    }
                    else if (element.item.inventoryType === "B") {
                        acctotal += qty * element.item.dealerPrice;
                    }
                    else {
                        othertotal += qty * element.item.dealerPrice;
                    }
                    arr.push(element);
                    skuqty.push({
                        sku: element.item.distitemNbr,
                        qty: element.item.qtyOrdered
                    });
                }
               
            });
        }
        //for (const value of crrMap.values()) {
        //    skuqty.push({
        //        sku: value.item.distitemNbr,
        //        qty: value.item.qty
        //    });
        //}
        setItemsNumberQtyArr(skuqty);
        //UpdateSKUQty(crrMap);
        setSelectedItems(crrMap);
        setAccSubtotal(acctotal);
        setParSubtotal(parttotal);
        setOtherSubtotal(othertotal);
        //setValuesForItemInquiry(arr);
        let newCartItems = items;
        if (arr.length > 0) {
            newCartItems.push(...arr);
        }
        const newCart = {
            alerts: [],
            items: newCartItems
        }
        UpdateShoppingCart(newCart);
        setShoppingCart(newCart);
        //setValuesForItemInquiry(null);
        handleClosePop();
        setBulkLoad(null);
        setAlerts(alerts);
        setUpdateMode(false);
    };

    useEffect(() => {
        if (SelectedOrderType === '') {
            handleClosePop();
            return;
        }
        GetSKUDetail();
        //handlePop();
        LoadShipMethods();
    }, [ItemsNumberQtyArr, ShipToDealerID, SelectedOrderType])

    const handleSelectionChange = (e, data) => {


    };

    const GetSKUDetail = async () => {
        if (!selectedItems || selectedItems.size === 0 || SelectedOrderType === '') {
            return;
        }
        if (UpdateMode === false) {
            return;
        }
        CheckSession();
        const user = GetCoockie();
        handlePop();
        const skuqty = {
            valueLabels: ItemsNumberQtyArr,
            orderType: SelectedOrderType,
            dealerID: user.dealerID
        };
        const rqst = {
            method: 'POST',
            headers: {
                'Content-type': 'application/json'
            },
            body: JSON.stringify(skuqty)
        };
        const res = await fetch('kdealer/GetSkuInfo/', rqst);
        if (res.status !== 200) {
            throw new Error(res.statusText);
        }
        const js = await res.json();
        const addInfo = new Map();
        const newSkuQty = [];
        const arrSubs = [];
        let errorSet = new Set();
        //setAlertLTL(false);
        let alertFactor = 0, boCount = 0;
        let LTL = false;
        let pk = false;
        console.log(js);
        js.map((item) => {
            if (item.distitemNbr !== "") {
                newSkuQty.push({
                    sku: item.distitemNbr,
                    qty: item.quantity
                }
                );
                if (item.substitutedSKU !== "") {
                    arrSubs.push(`${item.substitutedSKU} is substituted by ${item.distitemNbr}`);
                }
                if (item.factorAlert) {
                    alertFactor++;
                }
                if (item.boCnt > 0) {
                    boCount++;
                }
                if (item.ltl === true) {
                    LTL = true;
                }
                if (item.pk === true) {
                    pk = true;
                }
            }
            if (item.errorMsg !== "") {
                if (item.errorMsg.toLowerCase().indexOf("invalid") > -1) {
                    errorSet.add("At least one Item Number is invalid.");
                } else {
                    errorSet.add(item.errorMsg);
                }
            }
            return '';
        });
        //Item Number
        const skuqty2 = {
            valueLabels: newSkuQty,
            orderType: SelectedOrderType,
            dealerID: user.dealerID
        };
        const rqst2 = {
            method: 'POST',
            headers: {
                'Content-type': 'application/json'
            },
            body: JSON.stringify(skuqty2)
        };
        const res2 = await fetch('kdealer/GetSkuInfo2/', rqst2);
        if (res2.status !== 200) {
            throw new Error(res.statusText);
        }
        const js2 = await res2.json();

        js2.map((item) => {
            if (item.itemStaCode === "1") {
                addInfo.set(item.itemNumber, item);
            }
            return '';
        });

        let skuObjs = [];
        js.map((item) => {
            if (item.distitemNbr !== "") {
                const info = {
                    item: item,
                    addInfo: addInfo.get(item.distitemNbr.replaceAll('-', ''))
                }
                //if (item.itemStaCode === "1" || item.itemStaCode === "2") {
                //    //setSelectedSKUs(prev => new Set(prev).add(item.distitemNbr));

                //    //acctotal += item.qty * item.dealerPrice;
                //}
                skuObjs.push(info);
                //setSKUItems(prevSKUItems => new Map(prevSKUItems).set(item.distitemNbr, info));
            }
            return '';
        });
        const alerts = [
            alertFactor > 0 && { type: 'packQuantity' },
            boCount > 0 && { type: 'backorder' },
            LTL && { type: 'ltlShipping' },
            pk && { type: 'packageBuilt' },
            arrSubs.length > 0 && { type: 'substitutions' }
        ].filter(Boolean);
        handleSelectedItems({ items: skuObjs, alerts: alerts }, false);
        handleClosePop();
    }

    const GetForwarderDropshipAddress = async (val) => {
        if (val === "I4" || val === "I5" || val === "I6") {
            setSelectedDropshipAddress(ForwarderAddresses.get('D'));
            setSelectedForwarderAddress(null);
        }
        else if (val === "I7" || val === "I8") {
            setSelectedForwarderAddress(ForwarderAddresses.get('F'));
            setSelectedDropshipAddress(ForwarderAddresses.get('D'));
        }
        else {
            setSelectedForwarderAddress(null);
            setSelectedDropshipAddress(null)
        }
    }

    const DeleteSelectedItems = () => {
        const crrMap = new Map(selectedItems);
        let count = 0;
        $('input:checkbox:checked').each(function () {
            const id = $(this).attr('id');
            if (id.length > 5 && id.substring(0, 5) === "check") {
                crrMap.delete(id.substring(5));
                count++;
            }
        })
        if (count > 0) {
            setSelectedItems(crrMap);
            const valuesArray = Array.from(crrMap.values());
            handlePop();
            const newCart = {
                alerts: [],
                items: valuesArray
            }
            UpdateShoppingCart(newCart);
            setShoppingCart(newCart);
            $(':checkbox').prop('checked', false);
            UpdateSKUQty(crrMap);
            setUpdateMode(true);
        }
        handleDeleteModalClose();
    }

    const UpdateSKUQty = (crrMap) => {
        const skuqty = [];
        for (const value of crrMap.values()) {
            skuqty.push({
                sku: value.item.distitemNbr,
                qty: value.item.qtyOrdered
            });
        }
        setItemsNumberQtyArr(skuqty);
    }

    const LoadOrderType = async () => {
        try {
            const response = await fetch("kdealer/GetOrderType");
            if (response.status !== 200) {
                return;
            }
            const ordType = await response.json();
            setOrderTypes(ordType);
            if (ordType.length > 1) {
                setSelectedOrderType(ordType[1].value);
            }
        }
        catch (e) {
            console.log(e);
            return;
        }
    }

    useEffect(() => {
        if (OrderTypes && OrderTypes.length > 1) {
            setSelectedOrderType(OrderTypes[1].value);
        }
    }, [OrderTypes]);

    useEffect(() => {
        try {
            CheckSession();
            const cart = GetShoppingCart();
            if (cart && cart.items) {
                const crrMap = new Map();
                let acctotal = 0, parttotal = 0, othertotal = 0;
                const skuqty = [];
                cart.items.forEach(element => {
                    crrMap.set(element.item.distitemNbr, element);
                    //acctotal += element.item.qty * element.item.dealerPrice;
                    const qty = element.item.qty + element.item.boCnt;
                    if (element.item.inventoryType === "A") {
                        parttotal += qty * element.item.dealerPrice;
                    }
                    else if (element.item.inventoryType === "B") {
                        acctotal += qty * element.item.dealerPrice;
                    }
                    else {
                        othertotal += qty * element.item.dealerPrice;
                    }
                    skuqty.push({
                        sku: element.item.distitemNbr,
                        qty: element.item.qtyOrdered
                    });
                });
                setSelectedItems(crrMap);
                setAccSubtotal(acctotal);
                setParSubtotal(parttotal);
                setOtherSubtotal(othertotal);
                setShoppingCart(cart);
                setItemsNumberQtyArr(skuqty);
            }

        }
        catch (e) {

        }
    }, [localStorage.getItem(shopping_cart_session_id)])

    const handleChange = (event) => {
        const { name, value } = event.target;
        if (name === 'orderName') {
            setOrderName(value);
        } else if (name === 'dealerId') {
            setDealerIdInput(value);
            CheckDealerID(value);
        } else if (name === 'kCode') {
            setKCode(value);
        }
    };
    const CheckDealerID = async (id) => {
        try {
            const response = await fetch("kdealer/GetDefaultShipTo/" + id);
            if (response.status !== 200) {
                setDealerIDChangeMsg("Invalid User");
                return;
            }
            const add = await response.json();
            if (add && add.address) {
                setDealerIDChangeMsg(add.firstName);
                setDealerChanged(add);
            }
            else {
                setDealerIDChangeMsg("Invalid User");
            }
        }
        catch (e) {
            console.log(e);
            return;
        }
    }
    const LoadShipTo = async (id, isDefault) => {
        try {
            const response = await fetch("kdealer/GetDefaultShipTo/" + id);
            if (response.status !== 200) {
                return;
            }
            const add = await response.json();
            if (add && add.address) {
                if (isDefault) {
                    setDefaultShipTo(add);
                }
                setShipTo(add);
                setShipToDealerID(id);
            }
        }
        catch (e) {
            console.log(e);
            return;
        }
    }

    useEffect(() => {
        if (!OrderTypes) {
            LoadOrderType();
        }
    }, [OrderTypes])

    useEffect(() => {
        if (!ShipTo) {
            CheckSession();
            const user = GetCoockie();
            LoadShipTo(user.dealerID, true);
        }
    }, [ShipTo])

    useEffect(() => {
        setTotal(AccSubtotal + ParSubtotal + OtherSubtotal + EstFreight + EstHandling + EstSpecialFee);
    }, [AccSubtotal, ParSubtotal, OtherSubtotal, EstFreight, EstHandling, EstSpecialFee])

    const handleMemoChange = (e) => {
        if (selectedItems && selectedItems) {
            const vl = e.target.value.trim();
            const id = e.target.id.replace('memo-', '');
            const item = selectedItems.get(id);
            if (item && item.item && item.item.memo !== vl) {
                item.item.memo = vl;
                const map = new Map(selectedItems);
                map.set(id, item);
                setSelectedItems(map);
                setUpdateMode(false);
            }
        }
    };

    const debounceRef = useRef({});

    const updateQuantity = (id, vl) => {
        const item = selectedItems.get(id);
        if (!item || item.item.qtyOrdered === vl) return;

        //handlePop();        

        setLocalQty(prev => {
            const updated = {
                ...prev,
                [id]: vl,
            };
            if (ItemsNumberQtyArr && ItemsNumberQtyArr.length > 0) {
                const skuqty = [];
                ItemsNumberQtyArr.forEach(element => {
                    skuqty.push({
                        sku: element.sku,
                        qty: element.sku === id ? vl : element.qty
                    });
                });
                setItemsNumberQtyArr(skuqty);
                setUpdateMode(true);
            }
            return updated;
        });       
    }

    const handleOrderQtyChange = (e) => {
        const id = e.target.id.replace('qty-', '');
        const input = e.target.value;

        setLocalQty(prev => ({
            ...prev,
            [id]: input,
        }));

        if (input !== '') {
            const raw = ValidateQty(input);
            if (raw.length > 0) {
                const vl = parseInt(raw);
                clearTimeout(debounceRef.current[id]);

                debounceRef.current[id] = setTimeout(() => {
                    updateQuantity(id, vl);
                }, 800); // 800ms debounce
            }
        }
    }

    const handleOrderQtyBlur = (e) => {
        const id = e.target.id.replace('qty-', '');
        const input = e.target.value.trim();

        clearTimeout(debounceRef.current[id]);

        if (input === '' || parseInt(input) < 1) {
            setLocalQty((prev) => ({
                ...prev,
                [id]: selectedItems.get(id)?.item.qtyOrdered ?? 1, 
            }));

            handleQtyModalShow();
            return;
        }

        const raw = ValidateQty(input);
        const vl = parseInt(raw);

        setLocalQty(prev => ({
            ...prev,
            [id]: vl,
        }));

        updateQuantity(id, vl);
    }

    const LoadShipMethods = async () => {
        try {
            CheckSession();
            const session = GetCoockie();
           
            if (!selectedItems || selectedItems.size === 0 || !ShipToDealerID || !SelectedOrderType) {
                return;
            }
            handlePop();
            let arr = [];
            Array.from(selectedItems.values()).forEach(element => {
                arr.push(element.item);
            });
            const data = {
                orderType: SelectedOrderType,
                shipToDealerID: ShipToDealerID,
                dealerId: session.dealerID,
                items: arr,
                over1000d: AccSubtotal > 1000
            }
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(data)
            };

            const res = await fetch('kdealer/GetFreightInfo', requestOptions);

            if (res.status === 200) {
                const js = await res.json();
                setShipCodes(js);
            }
            if (session.loginType === 5) {
                LoadShipMethodsInternaltion(session.dealerID);
            }
            handleClosePop();
            return true;
        }
        catch (e) {
            console.log(e);
            handleClosePop();
            return false;
        }
    }
    useEffect(() => {
        if (ShipCodes && ShipCodes.length > 0) {
            ChangeShipMethod(ShipCodes[0].key);
        }
    }, [ShipCodes])

    const SendSKUQtyToItemInquiry = async (skuqty) => {
        if (!skuqty) {
            return;
        }
        handleImportModalClose();
        //setValuesForItemInquiry(null);
        setBulkLoad(skuqty);
        setFromImport(true);
        setShowItemModal(true);
    }

    const LoadShipMethodsInternaltion = async (dealerID) => {
        try {

            if (!selectedItems || selectedItems.size === 0 || !dealerID || !SelectedOrderType) {
                return;
            }
            const res = await fetch('kdealer/GetInternationlForwardInfo/' + dealerID);

            if (res.status === 200) {
                const js = await res.json();
                const map = new Map();
                const submap = new Map();
                js.forEach(element => {
                    map.set(element.type, element.addresses);
                    element.addresses.forEach(d => {
                        submap.set(d.carrCode, d);
                    });
                });
                setForwarderAddresses(map);
                setAllForwarderAddMap(submap);
                console.log(map);
                return true;
            }
        }
        catch (e) {
            console.log(e);
            return false;
        }
        return false;
    }
    const handleClickOrderID = () => {
        if (!OrderID || OrderID === '') {
            return;
        }
        navigate('/OrderHistory', { state: { id: OrderID } });
    }
    const SubmitOrder = async () => {
        try {
            CheckSession();
            let validated = true;

           
            const char1 = ShipMethod.substring(0, 1);
            const char2 = parseInt(ShipMethod.substring(1, 2))
            $('#SelectForwarderAdd').removeClass('is-invalid');
            $('#SelectShipMethod').removeClass('is-invalid');
            $('#SelectOrderType').removeClass('is-invalid');
            if (SelectedOrderType === '') {
                $('#SelectOrderType').addClass('is-invalid');
                validated = false;
            }
            if (!ShipMethod) {
                $('#SelectShipMethod').addClass('is-invalid');
                validated = false;
            }
            else if (char1 === "I" && char2 > 3) {
                if (!DropShipAdd) {
                    $('#SelectDropShipAdd').addClass('is-invalid');
                    validated = false;
                }
                if (char2 >= 7 && !ForwarderAdd) {
                    $('#SelectForwarderAdd').addClass('is-invalid');
                    validated = false;
                }
            }

            if (selectedItems.size === 0) {
                validated = false;
            }

            if (!validated) {
                return;
            }
            let items = [];
            for (const value of selectedItems.values()) {
                let val = value.item;
                val["memo"] = SKUMemo.has(value.item.distitemNbr) ? SKUMemo.get(value.item.distitemNbr) : '';
                items.push(val);
            }

            const session = GetCoockie();
            const data = {
                /* body: {*/
                orderName: OrderName ? OrderName : '',
                orderType: SelectedOrderType,
                /* itemExchange: ItemExchange,*/
                shipToDealer: ShipToDealerID,
                shipToMethod: ShipMethod,
                partsSubtotal: ParSubtotal,
                accSubtotal: AccSubtotal,
                otherSubtotal: OtherSubtotal,
                estFreight: EstFreight,
                estHandling: EstHandling,
                estSpecialFee: EstSpecialFee,
                dealerId: session.dealerID,
                forwarderAddressCode: ForwarderAdd ? ForwarderAdd : '',
                dropshipAddressCode: DropShipAdd ? DropShipAdd : '',
                items: items
            }
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(data)
            };

            const resOrder = await fetch('kdealer/SubmitNewOrder', requestOptions);

            if (resOrder.status === 200) {
                setSubmit(true);
                const js = await resOrder.json();
                setOrderID(js.value);
                localStorage.clear();
                UpdateShoppingCart(null);
                setShoppingCart(null);
            }

        } catch (e) {
            console.log(e);
            return;
        }
    }

    const getStatusIcon = (code) => {
        const color = code.charAt(0);
        const number = code.slice(1);

        switch (color) {
            case "G":
                return (
                    <div className="icons-row">
                        <div className="status-icon green-icon"></div>
                    </div>
                );
            case "Y":
                return (
                    <div className="icons-row">
                        <div className="status-icon yellow-icon"></div>
                    </div>
                );
            default:
                return (
                    <div className="icons-row">
                        <div className="status-icon red-icon"></div>
                    </div>
                );
        }
    };

    useEffect(() => {
        document.title = 'K-Dealer - New Order';
    }, []);

    return (
        <>
            <Container className="checkout-container main-container">

                <Row className="help-title-row checkout-title-row">
                    <Col className="help-center-title checkout-title">
                        <h1 className="heading help-heading">ORDER FORM</h1>
                    </Col>
                    <Col className="checkout-title-under">
                    </Col>
                </Row>

                <Row className="dealer-section min-height-spacing">

                    <Col md={12}>

                        {!submit ?
                            <>
                                <Row className="mb-3">

                                    <Col sm={6}>
                                        <Card className="h-100">
                                            <Card.Body>
                                                <Row>
                                                    <Col sm={2}>
                                                        <div className="svg-holder large-svg"><img src="../../../Images/add-items-icon.svg" alt="" className="" /></div>
                                                    </Col>

                                                    <Col sm={6}>
                                                        <Card.Title className="heading mt-2" role="heading">ADD ITEMS</Card.Title>

                                                        <p>Use the Item Inquiry lookup to check item availability</p>
                                                    </Col>

                                                    <Col sm={4}>
                                                        <Button variant="primary" className="mt-4" onClick={handleItemModalShow}>
                                                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                            </svg>
                                                            ITEM INQUIRY
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    </Col>

                                    <Col sm={6}>
                                        <Card className="h-100">
                                            <Card.Body>
                                                <Row>
                                                    <Col sm={2}>
                                                        <div className="svg-holder large-svg"><img src="../../../Images/import-items-icon.svg" alt="" className="" /></div>
                                                    </Col>

                                                    <Col sm={6}>
                                                        <Card.Title className="heading mt-2" role="heading">IMPORT ITEMS</Card.Title>

                                                        <p>Import items from your DMS System</p>
                                                    </Col>

                                                    <Col sm={4}>
                                                        <Button variant="primary" className="mt-4" onClick={handleImportModalShow}>
                                                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                            </svg>
                                                            IMPORT ITEMS
                                                        </Button>

                                                        <p className="underline mt-3" onClick={handleShowImportInstructions}>Import Instructions</p>
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>

                                {selectedItems.size > 0 ?
                                    <>
                                        <Card className="m-t-sm mb-3">
                                            <Card.Body>
                                                <Row>
                                                    <Col sm={12}>
                                                        <Card>
                                                            <Card.Body>
                                                                <Row>
                                                                    <Col sm={12}>
                                                                        <Row className="">
                                                                            <Col sm={3}>
                                                                                <Card.Title className="vertical-line heading" role="heading">ORDER DETAILS</Card.Title>
                                                                            </Col>
                                                                            <Col sm={3}>
                                                                                <Form.Select id="SelectOrderType" aria-label="Select Order Type" className="tall-select" onChange={ChangeOrderType} value={SelectedOrderType}>
                                                                                    {OrderTypes && OrderTypes.map((d) =>
                                                                                        <option key={d.value} value={d.value}>{d.label}</option>
                                                                                    )}
                                                                                </Form.Select>
                                                                            </Col>
                                                                            <Col sm={3}>
                                                                                <FloatingLabel label="Order Name" className="mb-3" >
                                                                                    <Form.Control id="controlName" type="text" placeholder="Order Name" value={OrderName} className={'form-control'} onChange={handleChange} name="orderName" />
                                                                                </FloatingLabel>
                                                                            </Col>
                                                                        </Row>
                                                                    </Col>
                                                                </Row>
                                                            </Card.Body>
                                                        </Card>
                                                    </Col>
                                                </Row>

                                                <div className="sticky fixed-legend">
                                                    <Row className="table-legend mb-2">
                                                        <Col sm={1}>
                                                            <DropdownButton
                                                                variant="outline-dark"
                                                                title="Actions"
                                                                id="actions-dropdown"
                                                                className="mt-2 mb-2 dropdown-actions"
                                                            >
                                                                <Dropdown.Item onClick={handleDeleteModalOpen} ><span className="svg-holder"><img src="../../../Images/cancelled-inactive.svg" alt="Delete" /> Delete</span></Dropdown.Item>
                                                            </DropdownButton>
                                                        </Col>
                                                        <Col sm={11} className="text-center mt-2">
                                                            <div className="table-legend-section">
                                                                <span className="svg-holder"><img src="../../../Images/parts.svg" alt="" className="" /> Parts</span>
                                                                <span className="svg-holder"><img src="../../../Images/accessories.svg" alt="" className="" /> Accessories</span>
                                                                <span className="svg-holder"><img src="../../../Images/other.svg" alt="" className="" /> Other</span>
                                                            </div>

                                                            <div className="table-legend-section">
                                                                <span className="icons-row"><div className={`status-icon green-icon`}></div> Available</span>
                                                                <span className="icons-row"><div className={`status-icon yellow-icon`}></div> Partial</span>
                                                                <span className="icons-row"><div className={`status-icon red-icon`}></div> Unavailable</span>
                                                            </div>

                                                            <div className="table-legend-section">
                                                                <span className="svg-holder"><img className="asterisk-img" src={"../../../Images/asterisk.svg"} alt="asterisk" /> Pkg Qty</span>
                                                                <span className="svg-holder"><img src="../../../Images/substitute.svg" alt="" className="" /> Substitute</span>
                                                                <span className="svg-holder"><img className="" src={"../../../Images/LTL.svg"} alt="LTL" /> LTL</span>
                                                                <span className="svg-holder"><img src="../../../Images/backorder.svg" alt="" className="" /> Backorder</span>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>

                                                <div className="item-inquiry-list">
                                                    <div className="alerts-section" style={!hasAlert('packQuantity') && !hasAlert('ltlShipping') && !hasAlert('substitutions') && (AccSubtotal < 1000) && !hasAlert('backorder') && !hasAlert('packageBuilt') ? { border: "none" } : {}} >
                                                        <Row>
                                                            {hasAlert('packQuantity') &&
                                                                <Col sm={12}>
                                                                    <div className="icons-row alert-noti asterisk-noti text-left">
                                                                        <span className="svg-holder small-svg">
                                                                            <img className="asterisk-img" src={"../../../Images/asterisk.svg"} alt="asterisk"></img>
                                                                        </span>

                                                                        <p className="mb-0">There is at least one item with the order quantity increased to a factor of the package quantity.</p>
                                                                    </div>
                                                                </Col>
                                                            }
                                                            {hasAlert('ltlShipping') &&
                                                                <Col sm={12}>
                                                                    <div className="icons-row alert-noti ltl-noti text-left">
                                                                        <span className="svg-holder small-svg">
                                                                            <img className="" src={"../../../Images/LTL.svg"} alt="LTL"></img>
                                                                        </span>

                                                                        <p className="mb-0">Your whole order may ship LTL due to restrictions on the highlighted item(s)</p>
                                                                    </div>
                                                                </Col>
                                                            }
                                                            {hasAlert('substitutions') &&
                                                                <Col sm={12}>
                                                                    <div className="icons-row alert-noti substitute-noti text-left">
                                                                        <span className="svg-holder small-svg">
                                                                            <img className="red-filter" src={"../../../Images/substitute.svg"} alt="Substitute"></img>
                                                                        </span>

                                                                        <p className="mb-0">One or more items has been substituted on this order.</p>
                                                                    </div>
                                                                </Col>
                                                            }
                                                            {hasAlert('packageBuilt') &&
                                                                <Col sm={12}>
                                                                    <div className="icons-row alert-noti bo-noti text-left">
                                                                        <span className="svg-holder small-svg">
                                                                            <img src="../../../Images/backorder.svg" alt="Alert" />
                                                                        </span>

                                                                        <p className="mb-0">One or more packages built to order</p>
                                                                    </div>
                                                                </Col>
                                                            }
                                                            {hasAlert('backorder') &&
                                                                <Col sm={12}>
                                                                    <div className="icons-row alert-noti bo-noti text-left">
                                                                        <span className="svg-holder small-svg">
                                                                            <img src="../../../Images/backorder.svg" alt="Alert" />
                                                                        </span>

                                                                        <p className="mb-0">One or more items are backordered</p>
                                                                    </div>
                                                                </Col>
                                                            }
                                                            {AccSubtotal > 1000 &&
                                                                <Col sm={12}>
                                                                    <div className="icons-row alert-noti bo-noti text-left">
                                                                        <p className="red mb-0 text-left padding-left-extra">Air shipping options are not available for orders totalling $1000.00 or more.</p>
                                                                    </div>
                                                                </Col>
                                                            }
                                                        </Row>
                                                    </div>

                                                    {Array.from(selectedItems.values()).map((d, index) => (
                                                        <div key={"sku" + index.toString()} className="item-inquiry-item">
                                                            <Row>
                                                                {d.item.factorAlert &&
                                                                    <Col sm={12}>
                                                                        <div className="icons-row alert-noti asterisk-noti text-left">
                                                                            <span className="svg-holder small-svg">
                                                                                <img className="asterisk-img white-filter" src={"../../../Images/asterisk.svg"} alt="asterisk"></img>
                                                                            </span>

                                                                            <p className="mb-0">This item's quantity has been increased to a factor of the package quantity.</p>
                                                                        </div>
                                                                    </Col>
                                                                }
                                                                {d.item.ltl &&
                                                                    <Col sm={12}>
                                                                        <div className="icons-row alert-noti ltl-noti text-left">
                                                                            <span className="svg-holder small-svg">
                                                                                <img className="white-filter" src={"../../../Images/LTL.svg"} alt="LTL"></img>
                                                                            </span>

                                                                            <p className="mb-0">Your whole order may ship LTL due to restrictions on the highlighted item(s)</p>
                                                                        </div>
                                                                    </Col>
                                                                }
                                                                {d.item.substitutedSKU !== '' &&
                                                                    <Col sm={12}>
                                                                        <div className="icons-row substitute-noti alert-noti text-left">
                                                                            <span className="svg-holder small-svg">
                                                                                <img className="white-filter" src={"../../../Images/" + d.item.statusIcon} alt={d.item.statusIcon}></img>
                                                                            </span>

                                                                            <p className="mb-0">Item No: {d.item.substitutedSKU} is substituted by Item No: {d.item.distitemNbr}</p>
                                                                        </div>
                                                                    </Col>
                                                                }
                                                                {d.item.pk &&
                                                                    <Col sm={12}>
                                                                        <div className="icons-row alert-noti bo-noti text-left">
                                                                            <span className="svg-holder small-svg">
                                                                                <img className="white-filter" src="../../../Images/backorder.svg" alt="Alert" />
                                                                            </span>

                                                                            <p className="mb-0">Package built to order</p>
                                                                        </div>
                                                                    </Col>   
                                                                }
                                                                {d.item.boCnt > 0 &&
                                                                    <Col sm={12}>
                                                                        <div className="icons-row alert-noti bo-noti text-left">
                                                                            <span className="svg-holder small-svg">
                                                                                <img className="white-filter" src="../../../Images/backorder.svg" alt="Alert" />
                                                                            </span>

                                                                            <p className="mb-0">This item is backordered</p>
                                                                        </div>
                                                                    </Col>
                                                                }
                                                            </Row>

                                                            <Row>
                                                                <Col sm={1} className="mt-5 text-center">
                                                                    <Form.Check type="checkbox" name="return_items" aria-label='Return Item' id={'check' + d.item.distitemNbr} defaultChecked={false} onChange={(e) => handleSelectionChange(e, d.item)} />
                                                                </Col>

                                                                <Col sm={11}>
                                                                    <Row className="mt-3">
                                                                        <Col sm={4} lg={1}>
                                                                            <img src={KImageURL(d.item.distitemNbr, d.addInfo.img)}
                                                                                onError={({ currentTarget }) => {
                                                                                    currentTarget.onerror = null;
                                                                                    currentTarget.src = DefaultImage;
                                                                                }}
                                                                                alt="Product"
                                                                                className={d.item.factorAlert || d.item.statusIcon.indexOf('.svg') > -1 || d.item.ltl || d.item.substitutedSKU !== '' || d.item.boCnt > 0 ? "item-image red-border" : "item-image"}>
                                                                            </img>
                                                                        </Col>
                                                                        <Col sm={4} lg={3} className="text-left">
                                                                            <p className={d.item.factorAlert || d.item.statusIcon.indexOf('.svg') > -1 || d.item.ltl || d.item.substitutedSKU !== '' || d.item.boCnt > 0 ? "mb-0 red" : "mb-0"}>{d.addInfo && d.addInfo.itemDesc}</p>
                                                                            <p className="mb-0">Item No: {d.item.distitemNbr}</p>
                                                                            <div className="icons-row">
                                                                                <span className="svg-holder small-svg">
                                                                                    <img src={"../../../Images/" + d.item.inventoryTypeIcon} alt={d.item.inventoryTypeIcon} ></img>
                                                                                </span>

                                                                                {d.item.statusIcon.indexOf('.svg') > -1 ?
                                                                                    <>|<span className="svg-holder small-svg"><img className="margin-left" src={"../../../Images/" + d.item.statusIcon} alt={d.item.statusIcon}></img></span></> :
                                                                                    <>|<span className="svg-holder small-svg"><div className={`status-icon ${d.item.statusIcon}`}></div></span></>
                                                                                }

                                                                                {d.item.boCnt > 0 && <>|<span className="svg-holder small-svg"><img src="../../../Images/backorder.svg" alt="Alert" className="margin-left" /></span></>}

                                                                                {d.item.factorAlert &&
                                                                                    <>|<span className="svg-holder small-svg"><img src="../../../Images/asterisk.svg" alt="asterisk" className="asterisk-img margin-left" /></span></>
                                                                                }

                                                                                {d.item.ltl &&
                                                                                    <>|<span className="svg-holder small-svg"><img src="../../../Images/LTL.svg" alt="LTL" className="margin-left" /></span></>
                                                                                }
                                                                            </div>

                                                                            <Row>
                                                                                <Col>
                                                                                    {d.addInfo &&
                                                                                        <DropdownButton
                                                                                            variant="outline-dark"
                                                                                            title="View Details"
                                                                                            id="details-dropdown"
                                                                                            className="mt-2 mb-2 dropdown-info"
                                                                                        >
                                                                                            <Dropdown.ItemText><span className="bold">Vehicle Use:</span> {d.addInfo.prodLinesText}</Dropdown.ItemText>
                                                                                            <Dropdown.Item><span className="bold">Model Year(s):</span> {d.addInfo.yearString} <span className="underline" onClick={() => handleModelModalShow(d.item.distitemNbr)}>View Models</span></Dropdown.Item>
                                                                                            <Dropdown.Item><span className="bold">Eligible Exchange/Return:</span> {d.addInfo.eligibleExchangeReturn}</Dropdown.Item>
                                                                                            <Dropdown.Item><span className="bold">Dimensions (LxWxHxG) (In):</span> {d.addInfo.dimentions}</Dropdown.Item>
                                                                                            <Dropdown.Item><span className="bold">Weight (lb) / Volume (ci):</span> {d.addInfo.weightVal}</Dropdown.Item>
                                                                                        </DropdownButton>
                                                                                    }
                                                                                </Col>
                                                                                <Col className={!showMemo[d.item.distitemNbr] && "mt-3"}>
                                                                                    {!showMemo[d.item.distitemNbr] ?
                                                                                        <p className="underline mb-0" onClick={() => toggleMemo(d.item.distitemNbr)}>+ Add Memo</p>
                                                                                        :
                                                                                        <FloatingLabel label="Add Memo" className="mb-3 mt-2" >
                                                                                            <Form.Control
                                                                                                id={`memo-${d.item.distitemNbr}`}
                                                                                                type="text"
                                                                                                placeholder="Add Memo"
                                                                                                name="addMemo"
                                                                                                className={'form-control'}
                                                                                                maxLength="200"
                                                                                                onChange={handleMemoChange}
                                                                                            />
                                                                                        </FloatingLabel>
                                                                                    }
                                                                                </Col>
                                                                            </Row>
                                                                        </Col>
                                                                        <Col sm={3} lg={1}>
                                                                            <Table bordered>
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th className="black-bg">Order <br /> Qty</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    <tr>
                                                                                        <td>
                                                                                            <Form.Control
                                                                                                type="number"
                                                                                                id={`qty-${d.item.distitemNbr}`}
                                                                                                aria-describedby="Order Quantity"
                                                                                                className={'form-control small-text-field'}
                                                                                                onBlur={handleOrderQtyBlur}
                                                                                                onChange={handleOrderQtyChange}
                                                                                                value={localQty[d.item.distitemNbr] ?? (d.item.qtyOrdered + d.item.boCnt)}
                                                                                            />
                                                                                        </td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </Table>
                                                                        </Col>
                                                                        <Col sm={9} lg={5}>
                                                                            <Table bordered>
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th>Avail <br /> Qty</th>
                                                                                        <th>CA (L)</th>
                                                                                        <th>TX (R)</th>
                                                                                        <th>KY (D)</th>
                                                                                        <th>Pkg <br /> Qty</th>
                                                                                        {d.item.boCnt > 0 && <th>BO</th>}
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    <tr>
                                                                                        <td>{d.item.qty}</td>
                                                                                        <td>{getStatusIcon(d.item.warehouseAvailColorL)}</td>
                                                                                        <td>{getStatusIcon(d.item.warehouseAvailColorR)}</td>
                                                                                        <td>{getStatusIcon(d.item.warehouseAvailColorD)}</td>
                                                                                        <td>{d.item.whslePkgCnt}</td>
                                                                                        {d.item.boCnt > 0 && <td>{d.item.boCnt}</td>}
                                                                                    </tr>
                                                                                </tbody>
                                                                            </Table>
                                                                        </Col>

                                                                        <Col sm={4} lg={2}>
                                                                            <Table bordered>
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th>Unit <br /> Price</th>
                                                                                        <th>Item <br /> Total</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    <tr>
                                                                                        <td>${d.item.dealerPrice.toFixed(2)}</td>
                                                                                        <td>${(d.item.dealerPrice * (d.item.qty + d.item.boCnt)).toFixed(2)}</td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </Table>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>

                                                            </Row>
                                                        </div>
                                                    ))}
                                                </div>
                                            </Card.Body>
                                        </Card>

                                        <Row className="d-flex">
                                            <Col sm={8} className="mb-5">
                                                <Card className="mb-3 h-100">
                                                    <Card.Body>
                                                        <Row>
                                                            <Col sm={6}>
                                                                <Card.Title className="vertical-line heading" role="heading">SHIP TO <span className="smaller-text underline" onClick={handleDealerModalShow}>(Change Dealer)</span></Card.Title>
                                                                {(SelectedForwarderAddress || SelectedDropshipAddress) &&
                                                                    <>
                                                                        <Card.Title className="vertical-line heading" role="heading">Forwarder/Dropship Address Information</Card.Title>
                                                                        {SelectedForwarderAddress &&
                                                                            <Row className="m-t-md">
                                                                                <Col sm={6}>
                                                                                    <Form.Select id="SelectForwarderAdd" aria-label="Select Forwarder Address" value={ForwarderAdd} onChange={(e) => ChangeForwarderAddress(e.target.value)}>
                                                                                        <option>Select Forwarder Address</option>
                                                                                        {SelectedForwarderAddress.map((item) => (
                                                                                            <option value={item.carrCode} key={item.carrCode}>{item.crrName + ' ' + item.add
                                                                                                + ' ' + item.city + ' ' + item.stateCode + ' ' + item.zip}</option>
                                                                                        ))}

                                                                                    </Form.Select>
                                                                                </Col>
                                                                            </Row>}
                                                                        {SelectedDropshipAddress &&
                                                                            <Row className="m-t-md">
                                                                                <Col sm={6}>
                                                                                    <Form.Select id="SelectDropShipAdd" aria-label="Select Dropship Addresses" value={DropShipAdd} onChange={(e) => ChangeDropShipAddress(e.target.value)}>
                                                                                        <option>Select Dropship Address</option>
                                                                                        {SelectedDropshipAddress.map((item) => (
                                                                                            <option value={item.carrCode} key={item.carrCode}>{item.crrName + ' ' + item.add
                                                                                                + ' ' + item.city + ' ' + item.stateCode + ' ' + item.zip}</option>
                                                                                        ))}

                                                                                    </Form.Select>
                                                                                </Col>
                                                                            </Row>
                                                                        }
                                                                    </>
                                                                }
                                                                {ShipTo &&
                                                                    <p className="m-t-md">{ShipTo.firstName} <br />
                                                                        {ShipTo.address} <br />
                                                                        {ShipTo.cityStateZip} <br />
                                                                        {ShipTo.countryCode}
                                                                    </p>
                                                                }

                                                                <Button variant="secondary" style={{ display: 'none' }}>
                                                                    <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                                                        <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                                    </svg>
                                                                    SAVE ORDER
                                                                </Button>
                                                            </Col>

                                                            <Col sm={6} className="text-left">
                                                                <Card.Title className="vertical-line heading" role="heading">SHIP METHOD</Card.Title>

                                                                <Row className="m-t-md">
                                                                    <Col sm={8}>
                                                                        <Form.Select id="SelectShipMethod" aria-label="Select Ship Method" value={ShipMethod} onChange={(e) => { ChangeShipMethod(e.target.value) }}>
                                                                            {/* <option>Select Ship Method</option>*/}
                                                                            {ShipCodes && ShipCodes.map((item) => (
                                                                                <option value={item.shipCode.substring(0, 1) === "I" ? item.shipCode : item.key} key={item.shipCode}>{item.shipMethodName}</option>
                                                                            ))}
                                                                        </Form.Select>
                                                                    </Col>
                                                                </Row>

                                                            </Col>
                                                        </Row>
                                                    </Card.Body>
                                                </Card>
                                            </Col>

                                            {/*<Col sm={4}></Col>*/}
                                            <Col sm={4} className="mb-5">
                                                <Card className="summary-card mb-0">
                                                    <Card.Body>
                                                        <Row className="title-group summary-title keep-layout checkout-title-row">
                                                            <Col className="checkout-title">
                                                                <Card.Title className="vertical-line heading" role="heading">ORDER SUMMARY</Card.Title>
                                                                {/*<Card.Title className="heading" role="heading">ORDER SUMMARY</Card.Title>*/}
                                                            </Col>
                                                            {/*<Col className="checkout-title-under">*/}
                                                            {/*</Col>*/}
                                                        </Row>
                                                        <Row className="keep-layout">
                                                            <Col lg={6} md={8} sm={6}>
                                                                <p>Parts Subtotal</p>
                                                            </Col>
                                                            <Col lg={6} md={4} sm={6}>
                                                                <p className="right-text heading" id="partsSubtotal">{FormatCurrency(ParSubtotal)}</p>
                                                            </Col>
                                                        </Row>
                                                        <Row className="keep-layout">
                                                            <Col lg={6} md={8} sm={6}>
                                                                <p>Acc Subtotal</p>
                                                            </Col>
                                                            <Col lg={6} md={4} sm={6}>
                                                                <p className="right-text heading" id="accSubtotal">{FormatCurrency(AccSubtotal)}</p>
                                                            </Col>
                                                        </Row>
                                                        <Row className="keep-layout">
                                                            <Col lg={6} md={8} sm={6}>
                                                                <p>Other Subtotal</p>
                                                            </Col>
                                                            <Col lg={6} md={4} sm={6}>
                                                                <p className="right-text heading" id="otherSubtotal">{FormatCurrency(OtherSubtotal)}</p>
                                                            </Col>
                                                        </Row>
                                                        <Row className="keep-layout">
                                                            <Col lg={6} md={8} sm={6}>
                                                                <p>Est Freight</p>
                                                            </Col>
                                                            <Col lg={6} md={4} sm={6}>
                                                                <p className="right-text heading" id="freight">{FormatCurrency(EstFreight)}</p>
                                                            </Col>
                                                        </Row>
                                                        <Row className="keep-layout">
                                                            <Col lg={6} md={8} sm={6}>
                                                                <p>Est Handling</p>
                                                            </Col>
                                                            <Col lg={6} md={4} sm={6}>
                                                                <p className="right-text heading" id="handling">{FormatCurrency(EstHandling)}</p>
                                                            </Col>
                                                        </Row>
                                                        <Row className="keep-layout">
                                                            <Col lg={6} md={8} sm={6}>
                                                                <p>Est Special Fee</p>
                                                            </Col>
                                                            <Col lg={6} md={4} sm={6}>
                                                                <p className="right-text heading" id="specialFee">{FormatCurrency(EstSpecialFee)}</p>
                                                            </Col>
                                                        </Row>
                                                        <Row className="keep-layout">
                                                            <Col lg={6} md={8} sm={6}>
                                                                <p>K-Code</p>
                                                            </Col>
                                                            <Col lg={6} md={4} sm={6}>
                                                                {showPromo ?
                                                                    <>
                                                                        <FloatingLabel label="Add K-Code" >
                                                                            <Form.Control
                                                                                id="kCode"
                                                                                type="text"
                                                                                placeholder="Add K-Code"
                                                                                name="kCode"
                                                                                className={'form-control'}
                                                                                maxLength="20"
                                                                                onChange={handleChange}
                                                                            />
                                                                        </FloatingLabel>
                                                                    </>
                                                                    :
                                                                    <>
                                                                        <p className="right-text underline" id="promoCode" onClick={() => setShowPromo(true)}>+ Add</p>
                                                                    </>
                                                                }
                                                            </Col>
                                                        </Row>
                                                        <hr></hr>
                                                        <Row className="title-group summary-title keep-layout">
                                                            <Col sm={6}>
                                                                <Card.Title className="heading" role="heading">TOTAL</Card.Title>
                                                            </Col>
                                                            <Col sm={6}>
                                                                <Card.Title className="right-text heading">{FormatCurrency(Total)}</Card.Title>
                                                            </Col>
                                                        </Row>
                                                        <hr></hr>
                                                        <Row>
                                                            <Col sm={12} className="text-right">
                                                                <Button controlid='btnContinue' variant="primary" className="submit mb-0" onClick={SubmitOrder}>
                                                                    <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                                                        <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                                    </svg>
                                                                    SUBMIT
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        </Row>

                                    </>
                                :
                                    <>
                                        <Card className="m-t-sm mb-3">
                                            <Card.Body>
                                                <Row>
                                                    <Col sm={12} className="text-center">
                                                        <p className="bold mt-5 mb-5 svg-carat">
                                                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                                                <path transform="rotate(-90 8 8)" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                            </svg>
                                                            Add item(s) above to begin your order
                                                        </p>
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    </>
                                }
                            </>
                            :
                            <>
                                <Card className="mb-3">
                                    <Card.Body>
                                        <Row>
                                            <Col className="text-center">
                                                <h1 className="vertical-line heading confirmation-heading">THANK YOU FOR YOUR ORDER!</h1>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm={12} className="text-center mb-4">
                                                <h3 className="heading order-confirmation confirmation-heading">YOUR REFERENCE NUMBER IS <span className="underline green-text" onClick={() => handleClickOrderID()}>{OrderID ? OrderID : ""}</span></h3>
                                                <p>You will recieve an email with your order confirmation!</p>
                                                <p>Thanks for shopping with Kawasaki!</p>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm={6} className="text-right">
                                                <Button variant="secondary" onClick={() => navigate("/orderhistory")}>
                                                    <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                                        <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                    </svg>
                                                    ORDER HISTORY
                                                </Button>
                                            </Col>
                                            <Col sm={6} className="text-left">
                                                <Button controlid='btnContinue' variant="primary" className="submit" onClick={() => navigate("/dealerhome")}>
                                                    <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                                        <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                    </svg>
                                                    HOMEPAGE
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </>
                        }

                    </Col>

                    {/*{!submit && */}
                    {/*}*/}

                </Row>
            </Container>

            <FooterDealer />

            <Modal className="loader-div" id="loader" show={pop} onHide={handleClosePop} size="lg" centered backdrop="static" keyboard={false}>
                <PulseLoader color="#66cc33" size="20px" margin="12px" />
            </Modal>

            <Modal show={showDealerModal} onHide={handleDealerModalClose} dialogClassName="dealer-section" centered>
                <Modal.Header closeButton>
                    <Modal.Title>CHANGE DEALER</Modal.Title>
                    <CloseButton variant="white" data-bs-theme="dark" />
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm={12}>
                            <FloatingLabel controlId="floatingDealer" label="Dealer ID" className="mb-3">
                                <Form.Control type="number" placeholder="Dealer ID" value={DealerIdInput} onChange={handleChange} className="form-control" name="dealerId" />
                            </FloatingLabel>

                            <>{DealerIDChangeMsg ?? ''}</>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer className="text-right">
                    <Button variant="primary" onClick={ChangeDealer}>
                        <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                        </svg>
                        SAVE DEALER
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showModelModal} onHide={handleModelModalClose} backdrop="static" centered dialogClassName="dealer-section model-window">
                <Modal.Header closeButton style={{ justifyContent: 'center' }}>
                    <Modal.Title>MODELS</Modal.Title>
                    <CloseButton variant="white" data-bs-theme="dark" />
                </Modal.Header>
                <Modal.Body>
                    {!Models ?
                        <PulseLoader color="#66cc33" size="20px" margin="12px" className="mt-5" />
                        :
                        <Table bordered hover striped>
                            <thead>
                                <tr>
                                    <td colSpan="3">{SelectedItemForModels && SelectedItemForModels.itemNum}, {SelectedItemForModels && SelectedItemForModels.itemName}</td>
                                </tr>
                                {Models.length > 0 && <tr>
                                    <td colSpan="3">This item fits the following models:</td>
                                </tr>}

                            </thead>
                            <tbody>
                                {Models.length > 0 ? Models.map((d) =>
                                    <>
                                        {d.models.map((m) =>
                                            <tr>
                                                <td>{m.year}</td>
                                                <td>{m.label}</td>
                                                <td>{m.value}</td>
                                            </tr>)}
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    </>

                                ) :
                                    <tr>This item has no model restrictions.</tr>
                                }
                            </tbody>

                        </Table>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleModelModalClose}>
                        <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                        </svg>
                        CLOSE
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showQtyModal} onHide={handleQtyModalClose} dialogClassName="dealer-section" centered>
                <Modal.Header closeButton>
                    <Modal.Title>INVALID QTY</Modal.Title>
                    <CloseButton variant="white" data-bs-theme="dark" />
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm={12}>
                            <p>A minimum quantity of 1 is required for each item. The quantity has been reverted to its original value.</p>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>

            <Modal show={showDeleteModal} onHide={handleDeleteModalClose} dialogClassName="dealer-section" centered>
                <Modal.Header closeButton>
                    <Modal.Title>DELETE ITEM</Modal.Title>
                    <CloseButton variant="white" data-bs-theme="dark" />
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm={12}>
                            <p>Are you sure you want to remove this item from your cart?</p>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer style={{ display: 'block' }}>
                    <Row>
                        <Col sm={6} className="text-right">
                            <Button variant="secondary" onClick={handleDeleteModalClose}>
                                <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                </svg>
                                CANCEL
                            </Button>
                        </Col>
                        <Col sm={6} className="text-left">
                            <Button variant="primary" onClick={DeleteSelectedItems}>
                                <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                </svg>
                                REMOVE
                            </Button>
                        </Col>
                    </Row>
                </Modal.Footer>
            </Modal>

            <Modal show={importInstructions} onHide={handleCloseImportInstructions} scrollable dialogClassName="dealer-section" centered size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>IMPORT INSTRUCTIONS</Modal.Title>
                    <CloseButton variant="white" data-bs-theme="dark" />
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm={12}>
                            <h3>Import Order Specifications/Information</h3>

                            <ol className="text-left mt-3">
                                <li>
                                    <strong>File Information:</strong>
                                    <ol type="a">
                                        <li>Must be a .txt (ex: kicp0001.txt).</li>
                                        <li>Can be up to 56k in size.</li>
                                    </ol>
                                </li>

                                <li>
                                    <strong>Format Information:</strong>
                                    <ol type="a">
                                        <li>
                                            Each record must be 27 characters in length followed by a carriage return.
                                        </li>
                                        <li>
                                            Field Layout:
                                            <table border="1" cellpadding="8" cellspacing="0">
                                                <thead>
                                                    <tr>
                                                        <th>Field</th>
                                                        <th>Position</th>
                                                        <th>Length</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>ItemNumber</td>
                                                        <td>1-14</td>
                                                        <td>14</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Qty</td>
                                                        <td>15-17</td>
                                                        <td>3</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Memo</td>
                                                        <td>18-25</td>
                                                        <td>7</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Extra</td>
                                                        <td>26-27</td>
                                                        <td>3</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Carriage return</td>
                                                        <td colspan="2">-</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </li>
                                    </ol>
                                </li>

                                <li>
                                    <strong>Importing Process:</strong>
                                    <ol type="a">
                                        <li>Browse to the .txt file to import.</li>
                                        <li>Click "Import" button.</li>
                                        <li>
                                            The "View Import Order" page will display a maximum of 50 items at a time.
                                        </li>
                                        <li>Review items and quantities.</li>
                                        <li>Click the "Add All Items To Shopping Cart" to add all displayed items.</li>
                                        <li>
                                            If there are more items on the import file:
                                            <ol type="1">
                                                <li>
                                                    From the shopping cart page, click the "Continue to import additional order lines" link to process any remaining import order lines.
                                                </li>
                                                <li>Repeat the process until all items have been imported.</li>
                                            </ol>
                                        </li>
                                        <li>Order has been imported.</li>
                                        <li>Verify the item numbers and quantities before submitting the order.</li>
                                    </ol>
                                </li>
                            </ol>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer style={{ display: 'block' }} className="border-top">
                    <Row>
                        <Col sm={12} className="text-center">
                            <Button variant="secondary" onClick={handleCloseImportInstructions}>
                                <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                </svg>
                                CLOSE
                            </Button>
                        </Col>
                    </Row>
                </Modal.Footer>
            </Modal>

            <FileUpload show={importDealerModal} handleClose={handleImportModalClose} SendSKUQtyToItemInquiry={SendSKUQtyToItemInquiry} />

            <ItemInquiry show={showItemModal} handleClose={handleItemModalClose} handleSelectedItems={handleSelectedItems} orderType={SelectedOrderType} autoSubmit={false} bulkLoadData={BulkLoad} fromImport={fromImport} />

        </>
    );
}